import * as React from 'react';

import { ListingMobileListingMode } from '../ListingMobileListingMode';

export const ListingMobileContainer = () => {
  return <ListingMobileListingMode />;
};

ListingMobileContainer.displayName = 'ListingMobileContainer';
